import { IconSVG } from '../types';

export const Logo = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 33 32"
    style={style}
  >
    <g fill="#fff" clipPath="url(#clip0_5934_9466)">
      <path d="M28.95 15.648c-.004 1.032-.107 1.902-.517 2.707-.994 1.952-3.343 2.726-5.33 1.752-1.337-.655-2.664-1.332-3.997-1.995q-2.13-1.06-4.26.003c-1.206.601-2.406 1.218-3.62 1.804-2.539 1.227-5.473-.16-6.149-2.896-.68-2.75 1.429-5.411 4.266-5.384a4.34 4.34 0 0 1 1.929.47l3.523 1.763q2.18 1.093 4.36.004c1.3-.649 2.595-1.308 3.898-1.95a4.04 4.04 0 0 1 5.75 2.715c.088.374.112.764.147 1.009z" />
      <path d="M23.309 7.962c-.044 1.159-.556 2.07-1.622 2.622-1.06.55-2.135 1.078-3.209 1.602-1.012.495-2.037.5-3.052.008a197 197 0 0 1-3.148-1.567c-1.05-.535-1.632-1.403-1.675-2.58-.043-1.21.49-2.145 1.547-2.729 3.192-1.758 6.4-1.754 9.595-.005 1.02.56 1.526 1.456 1.562 2.649zM16.94 28c-1.773-.035-3.436-.468-4.945-1.41a2.963 2.963 0 0 1 .17-5.14q1.67-.87 3.367-1.681c.893-.426 1.828-.454 2.727-.04a59 59 0 0 1 3.53 1.745c2.014 1.094 2.027 3.987.041 5.17a9.4 9.4 0 0 1-4.363 1.327z" />
    </g>
    <defs>
      <clipPath id="clip0_5934_9466">
        <path fill="#fff" d="M4.95 4h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);
